import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import DashboardLayout from "@/pages/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import SocialPosts from "@/pages/SocialPosts";
import RoofMeasurement from "@/pages/RoofMeasurement";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Reviews from "@/pages/Reviews";
import QA from "@/pages/QA";
import Blog from "@/pages/Blog";
import AsphaltShingles from "@/pages/AsphaltShingles";
import MetalRoofs from "@/pages/MetalRoofs";
import TileRoofs from "@/pages/TileRoofs";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from '@/context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">
      <p className="font-manrope text-gray-600">Loading...</p>
    </div>;
  }
  
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/qa" element={<QA />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/roofs/asphalt-shingles" element={<AsphaltShingles />} />
              <Route path="/roofs/metal" element={<MetalRoofs />} />
              <Route path="/roofs/tile" element={<TileRoofs />} />
              <Route path="/login" element={<Auth />} />
              
              <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<Leads />} />
                <Route path="social" element={<SocialPosts />} />
                <Route path="roof-measurement" element={<RoofMeasurement />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;